import { AssetChangeReason } from 'enums';

// first elements on top
export const ASSET_CHANGE_REASON_ORDER = [
  AssetChangeReason.MerchantReferralCashback,
  AssetChangeReason.OrderCashback,
  AssetChangeReason.TraderReferralCashback,
  AssetChangeReason.ProviderReferralCashback,
  AssetChangeReason.CancelProviderReferralCashback,
  AssetChangeReason.PlatformCompensation,
  AssetChangeReason.DepositToBalance,
  AssetChangeReason.CancelledToDisputeOrder,
  AssetChangeReason.CompleteOrder,
  AssetChangeReason.CancelOrder,
  AssetChangeReason.ChangeOrder,
  AssetChangeReason.CreateOrder,
];
